export const DENIED_MSG = "Non disponi dei permessi necessari per accedere a questa sezione.";

export const can = (user, perm) => {
  if (!user || user.role !== "admin") return false;
  if (!perm) return true;
  return (user.permissions || []).includes(perm);
};
